import { ModifierScale } from '../ModifierScale';

import { modifierScalesState, activeModifierScaleState } from '../../atoms';
import { useRecoilValue } from 'recoil';

export const ModifierScales: React.FC = () => {
	const modifierScaleModel = useRecoilValue(modifierScalesState);
	const activeModifierScale = useRecoilValue(activeModifierScaleState);

	if (!modifierScaleModel) return null;

	return (
		<div className="product-modifier-scales">
			{[...modifierScaleModel.modifierScales]
				.sort((a, b) => a.priority - b.priority)
				.map((modifierScale, index) => (
					<ModifierScale
						key={index}
						modifierScaleIndex={index}
						isActive={index === activeModifierScale}
						modifierScale={modifierScale}
						selectedIndex={
							modifierScaleModel.modifierScaleIndices[index]
						}
					/>
				))}
		</div>
	);
};
